import React from 'react'
import styled, { css } from 'styled-components'

import WithForcedMonospace from './WithForcedMonospace'

import FlipMove from 'react-flip-move'
import { slideDownFadeInEnter, slideDownFadeOutLeave } from '../customFlipMoveAnimations'
import { useStore } from '../zustandStore'

const NUMBER_CHANGE_DURATION_MS = 350

const BingoPointsCell = ({ points, maxPoints, player, chapter, isPrepended, className, disableAllAnimations = false }) => {
  if (points == null || maxPoints == null) {
    points = player.chapterBingoPoints[chapter.shortName]
    maxPoints = chapter.bingoMaxPoints
  }

  // let maxDigits, spacerString

  // if (isPrepended) {
  //   maxDigits = String(maxPoints).length
  //   spacerString = '000'.slice(0, maxDigits)
  // }

  const {
    bingoPointsAnimationsEnabled
  } = useStore(state => ({
    bingoPointsAnimationsEnabled: state.publicAppSettings.bingoPointsAnimations
  }))

  return (
    <GridWrapper className={`bingo-points-cell-wrapper ${className || ''}`}>
      {/* FlipMove to animate this number ticking up as players check off objectives */}
      <FlipMove
        typeName={null}
        duration={NUMBER_CHANGE_DURATION_MS}
        enterAnimation={slideDownFadeInEnter()}
        leaveAnimation={slideDownFadeOutLeave()}
        disableAllAnimations={disableAllAnimations || bingoPointsAnimationsEnabled === false}
      >
        <PointsGridCell key={points}>
          <WithForcedMonospace>
            {points || 0}
          </WithForcedMonospace>
        </PointsGridCell>
      </FlipMove>

      {/* {isPrepended && (
        <PointsGridCell invisible>
          <WithForcedMonospace>
            {spacerString}
          </WithForcedMonospace>
        </PointsGridCell>
      )} */}

      <SlashGridCell className='max-points max-points-slash'>
        /
      </SlashGridCell>

      <MaxPointsGridCell className='max-points'>
        <WithForcedMonospace>
          {maxPoints || 0}
        </WithForcedMonospace>
      </MaxPointsGridCell>

    </GridWrapper>
  )
}

export default BingoPointsCell

const GridWrapper = styled.span`
  /* align-items: baseline; */
  display: grid;
  grid-template-columns: 1fr min-content 1fr;
  
  overflow-y: hidden; // this is for the slide up/down flipmove animations to actually look good
  
  // due to this component being a parent to a wrapperless flipmove, 
  // this position: relative is required and will get set by flipmove regardless
  position: relative; 
`

const PointsGridCell = styled.div`
  /* min-width: 1em;
  width: 1em;
  max-width: 1em; */
  grid-column: 1;
  grid-row: 1;
  text-align: right;
  ${props => props.invisible && css`
    visibility: hidden;
    /* color: red;
    opacity: 0.3; */
  `}
`

const SlashGridCell = styled.div`
  grid-column: 2;
  grid-row: 1;

  text-align: center;

  color: var(--bingo-points-chapter-maximum-color);
  opacity: 0.5;
`

const MaxPointsGridCell = styled.div`
  /* font-size: 0.9em; */
  grid-column: 3;
  grid-row: 1;

  color: var(--bingo-points-chapter-maximum-color);
  opacity: 0.5;

  text-align: left;
  ${props => props.invisible && css`
    visibility: hidden;
    /* color: red;
    opacity: 0.3; */
  `}
`


